import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function PlanHeaderText() {
    const { t } = useTranslation();

    return (
        <Row className="ml-1 header-program-ending mb-2">
            <Col className="plan-header-col" xs={12}>
                <h4 className="fw-bolder mb-3 plan-header">
                    {t("subscriptions.subscribe_and_get_everything")}
                </h4>
            </Col>
        </Row>
    );
}
